import { BigNumber } from '@ethersproject/bignumber'
import React from 'react'
import styled from 'styled-components'
import { Tooltip } from '../../common'
import { formatCurrency } from '../../model'

interface Props {
  liquidityBalance: BigNumber
  totalLiquiditySupply: BigNumber
}

export function PercentOfPoolTooltip({ liquidityBalance, totalLiquiditySupply }: Props) {
  return (
    <Tooltip>
      <p>Your deposit amount's percentage of pool.</p>
      <Table>
        <tbody>
          <tr>
            <th>Your LP Tokens</th>
          </tr>
          <tr>
            <td>{formatCurrency(18, liquidityBalance)}</td>
          </tr>
          <tr>
            <th>Total LP Tokens</th>
          </tr>
          <tr>
            <td>{formatCurrency(18, totalLiquiditySupply)}</td>
          </tr>
        </tbody>
      </Table>
    </Tooltip>
  )
}

const Table = styled.table`
  th {
    text-align: left;
  }
`
